export default __webpack_public_path__ + "static/media/isfp@3x.da2f7ed6.png";